import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d18d512a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-1" }
const _hoisted_2 = { class: "row form-group mb-1" }
const _hoisted_3 = { class: "col-sm-2 col-form-label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = { class: "row form-group" }
const _hoisted_7 = { class: "col-sm-2 col-form-label" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-sm-10" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center p-2"
}
const _hoisted_11 = {
  class: "remove-link",
  title: "削除"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" リンクを追加 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_url = _resolveComponent("input-url")!
  const _component_icon_circle_minus = _resolveComponent("icon-circle-minus")!
  const _component_icon_circle_plus = _resolveComponent("icon-circle-plus")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "d-flex flex-row mb-2"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.labelName), 1),
              (_ctx.maxLength > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_input_text, {
                modelValue: link.name,
                "onUpdate:modelValue": ($event: any) => ((link.name) = $event),
                required: _ctx.required || link.url !== ''
              }, null, 8, ["modelValue", "onUpdate:modelValue", "required"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.labelUrl), 1),
              (_ctx.maxLength > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(index + 1), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_input_url, {
                modelValue: link.url,
                "onUpdate:modelValue": ($event: any) => ((link.url) = $event),
                required: _ctx.required || link.name !== ''
              }, null, 8, ["modelValue", "onUpdate:modelValue", "required"])
            ])
          ])
        ]),
        (_ctx.links.length > _ctx.minLength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_icon_circle_minus, {
                  onClick: ($event: any) => (_ctx.removeLink(index))
                }, null, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.links.length < _ctx.maxLength)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-sm btn-link p-0 add-link",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addLink && _ctx.addLink(...args)))
        }, [
          _createVNode(_component_icon_circle_plus),
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ]))
}